import React from "react";
import Layout from "../../components/Layout/Layout";

const ConflictsOfInterest = () => {
    return (
        <Layout>
            <section className="page-hero">
                <div className="container">
                    <div className="eyebrow">
                        <span className="dot"></span> Conflicts of Interest
                    </div>
                    <h1>Conflicts of Interest</h1>
                    <p>
                        We are committed to identifying, managing, and, where necessary, disclosing conflicts of interest that may
                        arise in the course of providing our services.
                    </p>
                </div>
            </section>

            <section className="section section-tight">
                <div className="container grid-2">
                    <article className="card">
                        <span className="kicker">What is a conflict of interest?</span>
                        <h2>Definition</h2>
                        <p>
                            A conflict of interest may arise where our interests, or those of our employees or partners, differ from
                            the interests of our clients.
                        </p>
                    </article>

                    <article className="card">
                        <span className="kicker">How we manage conflicts</span>
                        <h2>Controls and procedures</h2>
                        <p>We implement internal policies and procedures designed to:</p>
                        <ul className="check-list micro-list">
                            <li>identify potential conflicts</li>
                            <li>prevent or manage conflicts effectively</li>
                            <li>ensure fair treatment of clients</li>
                        </ul>
                    </article>

                    <article className="card">
                        <span className="kicker">Examples</span>
                        <h2>Potential conflicts</h2>
                        <p>Conflicts may arise, for example, where:</p>
                        <ul className="check-list micro-list">
                            <li>we act as principal in a transaction</li>
                            <li>we use affiliated or third-party service providers</li>
                            <li>we receive fees or incentives from third parties</li>
                        </ul>
                    </article>

                    <article className="card">
                        <span className="kicker">Disclosure & policy</span>
                        <h2>Further information</h2>
                        <p>
                            Where a conflict cannot be effectively managed, we will disclose the nature of the conflict to clients
                            before providing the relevant service.
                        </p>
                        <p style={{ marginTop: 12 }}>
                            For full details, please refer to our{" "}
                            <a href="https://static-assets.everest.org/web/files/conflicts_of_interest_policy.pdf" target="_blank" style={{ color: "var(--brand)" }}>
                                Conflicts of Interest Policy
                            </a>
                            .
                        </p>
                    </article>
                </div>
            </section>
        </Layout>
    );
};

export default ConflictsOfInterest;

